<template>

	<transition name="slide-fade">

		<div>
			<img v-bind:src="pagina.better_featured_image.source_url" alt="">
			<h3 v-html="pagina.title.rendered"></h3>
			<span v-html="pagina.content.rendered"></span>

		</div>

	</transition>

</template>

<script>
export default {
	props:[
		'pagina',
	],
	mounted: function() {
		// this.getPage();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {

		// <div class="valor__item">
		// </div>

	 // 	<div v-if="pagina.acf.prev_tmpl!='iconos'" class="col-xs-12 npd block valor">
		// </div>
	},
	watch: {
		'$route'( to, from ) {
			// react to route changes...
			// this.getPage();
		}
	}
};
</script>



// WEBPACK FOOTER //
// page_iconos.vue?1d7a1933